module.exports = __webpack_public_path__ + "static/media/arrivalService.352952f7.png";